import styled from '@emotion/styled/macro';

export const Card = styled.div`
  box-shadow: inset 0 0 0 0.063rem ${({ theme }) => theme.color.primary40};
  border-radius: 0.25rem;
  display: flex;
  padding: 1.5rem;
`;
